/* eslint-disable no-undef */
import jwt from 'jsonwebtoken';
import moment from 'moment';

const JWT_STORAGE_KEY = 'catapult::sso';

export function addIdTokenLocalStorage(token) {
  localStorage.setItem(JWT_STORAGE_KEY, token);
}

export function removeIdTokenLocalStorage() {
  localStorage.removeItem(JWT_STORAGE_KEY);
}

export function hasIdTokenLocalStorage() {
  return !!localStorage.getItem(JWT_STORAGE_KEY);
}

export function getIdTokenLocalStorage() {
  return localStorage.getItem(JWT_STORAGE_KEY);
}

export function decodeToken(token) {
  const decoded = jwt.decode(token);
  return decoded;
}

export function isJwtValid(token) {
  try {
    const decoded = jwt.decode(token);
    const currentDate = moment.unix(moment().unix());
    const expiryDate = moment.unix(decoded.exp);
    return (
      moment(currentDate).isSameOrBefore(expiryDate)
    );
  } catch (error) {
    return false;
  }
}
